import React, { useState, useEffect } from "react";
import algoliasearch from "algoliasearch/lite";
import { InstantSearch, Hits, Configure, connectSearchBox, connectPagination } from "react-instantsearch-dom";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import { Button, Container, FormControl, Grid, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, ToggleButton, ToggleButtonGroup } from "@mui/material";
import Hit from "./Hit";
import "instantsearch.css/themes/reset.css";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";

export default function SearchJob() {
  const theme = useTheme();
  const searchClient = algoliasearch("SKKCC8UPXP", "5e55f2bb07b6d7b2cf97520ac06f34ea");
  const [loadPage, setLoadPage] = useState(10);
  const [loading, setloading] = useState(false);
  const [category, setCategory] = useState("Managment");
  let cat = [];
  Hit.propTypes = {
    hit: PropTypes.object.isRequired,
  };
  const handleChange = (event) => {
    setCategory(event.target.value);
  };
  console.log("cat", cat);

  async function Category() {
    const docRef = collection(db, "categories");
    await getDocs(docRef).then((categories) => {
      categories.forEach((category) => {
        cat.push(category.data());
      });
    });
    setloading(true);
  }
  useEffect(() => {
    Category();
  }, []);
  const SearchBox = ({ currentRefinement, refine }) => (
    <Container>
      <FormControl fullWidth variant="outlined">
        <OutlinedInput
          type="search"
          placeholder="Job title, NOC, ..."
          value={currentRefinement}
          onChange={(event) => refine(event.currentTarget.value)}
          sx={{
            background: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
          }}
          startAdornment={
            <InputAdornment position="start">
              <Box component={"svg"} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width={24} height={24}>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </Box>
            </InputAdornment>
          }
        />
      </FormControl>
    </Container>
  );

  const CustomSearchBox = connectSearchBox(SearchBox);

  // const Pagination = ({ currentRefinement, nbPages, refine, createURL }) => {
  //   const [alignment, setAlignment] = React.useState(1);

  //   const handleChange = (event, newAlignment) => {
  //     setAlignment(newAlignment);
  //   };
  //   return (
  //     <Box
  //       sx={{
  //         display: "flex",
  //         flexDirection: "column",
  //         alignItems: "center",
  //         padding: "2",
  //         "& > :not(style) + :not(style)": { mt: 2 },
  //       }}
  //     >
  //       <ToggleButtonGroup value={alignment} color="primary" exclusive onChange={handleChange}>
  //         {new Array(10).fill(null).map((_, index) => {
  //           const page = index + 1;
  //           const style = {
  //             fontWeight: currentRefinement === page ? "bold" : "",
  //             textDecoration: "none",
  //           };

  //           return (
  //             <ToggleButton key={index} size="small">
  //               <a
  //                 href={createURL(page)}
  //                 style={style}
  //                 onClick={(event) => {
  //                   event.preventDefault();
  //                   refine(page);
  //                 }}
  //               >
  //                 {page}
  //               </a>
  //             </ToggleButton>
  //           );
  //         })}
  //       </ToggleButtonGroup>
  //     </Box>
  //   );
  // };

  // const CustomPagination = connectPagination(Pagination);

  return (
    <Box bgcolor={"alternate.main"} paddingTop={6}>
      <Container>
        <Box>
          <Typography
            variant="h4"
            color="text.primary"
            align={"center"}
            gutterBottom
            sx={{
              fontWeight: 700,
            }}
          >
            Look for a job
          </Typography>
          <Typography variant="h6" component="p" color="text.secondary" sx={{ fontWeight: 200 }} align={"center"} paddingBottom={2}>
            Find the right career path for you
          </Typography>

          <InstantSearch searchClient={searchClient} indexName="jobs">
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <CustomSearchBox />
            </Box>

            <Configure filters={`status:true AND websites:newcomerneeds`} hitsPerPage={loadPage} />
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <Hits hitComponent={Hit} />
              <Box
                style={{
                  display: "flex",
                  color: "primary",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 10,
                }}
              >
                <Button onClick={() => setLoadPage(loadPage + 10)}>Load more</Button>
              </Box>
            </Box>
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                margin: 10,
              }}
            >
              {/* <CustomPagination /> */}
            </Box>
          </InstantSearch>
        </Box>
      </Container>
    </Box>
  );
}
